export default __webpack_public_path__ + "static/media/logo-cachaca.300e164f.png";